import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Loader from "js/Component/Loader";
import { fetchDevice } from "js/Api/index";
import { Button } from '../Component/CommonFormEle';
import { fetchKonnektForms, PostKonnektForm } from "js/Api/index";
import { hasValue } from "../helpers/common_functions";

const KonnektFormDisplay = (props) => {
    useEffect(() => {

        //const link = document.querySelector("link#favicon") || document.createElement('link');
        //link.rel = 'icon';
        //link.type = 'image/png';
        //link.href = '/images/konnekt_form_images/favicon_konnekt.png';
        //document.head.appendChild(link);

        document.title = 'Konnekt Build Options';
    }, []);

    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [openErrorModal, setopenErrorModal] = useState(false);
    const [currentForm, setcurrentForm] = useState();
    const [formSubmitted, setformSubmitted] = useState(false);
    const [openContactUs, setopenContactUs] = useState(false);
    const isReadOnly = currentForm?.status === "complete";
    const readOnlyTip = "Read only (already submitted)";
    const timeText = (v) => v || "";

    const handleSubmit = async (e) => {
        e.preventDefault();
    }

    const [formData, setFormData] = useState({

        accessory: 'none',
        placement: 'existing_table',

        internet: '',
        wifi_type: '',
        wifi_home_pre_configure: '',
        wifi_ssid: '',
        wifi_password: '',
        wifi_aged_care_configure: '',
        wifi_aged_care_special_req: '',

        dementia_disease: '',
        block_call_phone_call: '',
        video_phone_bedroom: '',

        turn_off_at: '',
        turn_off_again_at: '',

        auto_answer: '',
        auto_answer_yes_users: '',
        auto_answer_delay: '30sec',

        address1: '',
        address2: '',
        suburb: '',
        state: '',
        postcode: '',

        delivery_check: false,
        contact_name: '',
        contact_phone: '',

        delivery_address_check: false,
        installation_address1: '',
        installation_address2: '',
        installation_suburb: '',
        installation_state: '',
        installation_postcode: '',

        eme_contact_name: '',
        eme_contact_phone: '',

    });

    const formatTimeAmPm = (hhmm) => {
        if (!hhmm) return "";
        const [hhStr, mm] = hhmm.split(":");
        const hh = Number(hhStr);
        if (Number.isNaN(hh) || mm == null) return hhmm;

        const suffix = hh >= 12 ? "PM" : "AM";
        const h12 = hh % 12 === 0 ? 12 : hh % 12;
        return `${h12}:${mm} ${suffix}`;
    };

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const DeliveryAddressChange = (value) => {
        setFormData((prev) => ({ ...prev, ["delivery_address_check"]: value }));

        if (value === true) {
            setFormData((prev) => ({ ...prev, ["installation_address1"]: formData.address1 }));
            setFormData((prev) => ({ ...prev, ["installation_address2"]: formData.address2 }));
            setFormData((prev) => ({ ...prev, ["installation_suburb"]: formData.suburb }));
            setFormData((prev) => ({ ...prev, ["installation_state"]: formData.state }));
            setFormData((prev) => ({ ...prev, ["installation_postcode"]: formData.postcode }));
        }
        else {
            setFormData((prev) => ({ ...prev, ["installation_address1"]: "" }));
            setFormData((prev) => ({ ...prev, ["installation_address2"]: "" }));
            setFormData((prev) => ({ ...prev, ["installation_suburb"]: "" }));
            setFormData((prev) => ({ ...prev, ["installation_state"]: "" }));
            setFormData((prev) => ({ ...prev, ["installation_postcode"]: "" }));
        }
    }

    const GetData = async () => {
        setIsLoading(true);
        const searchParams = new URLSearchParams(location.search);
        const encodedData = searchParams.get("data");
        if (!encodedData) {
            window.location.href = "/"
        }
        const decoded = JSON.parse(atob(encodedData));

        const result = await fetchDevice(decoded.id);
        if (result.success && result.data) {
            setUser(result.data)

            document.title = 'Konnekt Build Options for ' + result.data.name;

            await GetKonnektForm(result.data.id);
            setIsLoading(false);
        }
        else {
            window.location.href = "/"
        }
    }

    const GetKonnektForm = async (device_id) => {
        const result = await fetchKonnektForms(device_id, "telstra");
        if (result.success && result.data) {
            if (result.data.length > 0) {
                setcurrentForm(result.data[0])
                if (result.data.length > 0 && hasValue(result.data[0].formData)) {
                    let db = JSON.parse(result.data[0].formData);
                    setFormData({
                        accessory: db?.accessory || 'none',
                        placement: db?.placement || 'existing_table',

                        internet: db?.internet || '',
                        wifi_type: db?.wifi_type || '',
                        wifi_home_pre_configure: db?.wifi_home_pre_configure || '',
                        wifi_ssid: db?.wifi_ssid || '',
                        wifi_password: db?.wifi_password || '',
                        wifi_aged_care_configure: db?.wifi_aged_care_configure || '',
                        wifi_aged_care_special_req: db?.wifi_aged_care_special_req || '',

                        dementia_disease: db?.dementia_disease || '',
                        block_call_phone_call: db?.block_call_phone_call || '',
                        video_phone_bedroom: db?.video_phone_bedroom || '',

                        turn_off_at: db?.turn_off_at || '',
                        turn_off_again_at: db?.turn_off_again_at || '',

                        auto_answer: db?.auto_answer || '',
                        auto_answer_yes_users: db?.auto_answer_yes_users || '',
                        auto_answer_delay: db?.auto_answer_delay || '30sec',

                        address1: db?.address1 || '',
                        address2: db?.address2 || '',
                        suburb: db?.suburb || '',
                        state: db?.state || '',
                        postcode: db?.postcode || '',

                        delivery_check: db?.delivery_check || false,
                        contact_name: db?.contact_name || '',
                        contact_phone: db?.contact_phone || '',

                        delivery_address_check: db?.delivery_address_check || false,
                        installation_address1: db?.installation_address1 || '',
                        installation_address2: db?.installation_address2 || '',
                        installation_suburb: db?.installation_suburb || '',
                        installation_state: db?.installation_state || '',
                        installation_postcode: db?.installation_postcode || '',

                        eme_contact_name: db?.eme_contact_name || '',
                        eme_contact_phone: db?.eme_contact_phone || '',
                    });
                }
            }
        }
    }

    const handleChange = (e) => {
        if (isReadOnly) return;
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSaveDraft = async (e) => {
        e.preventDefault();
        console.log(formData)
        var post_form = { form_type: "telstra", device_id: user.id, form_status: "draft", form_data: JSON.stringify(formData) }
        const result = await PostKonnektForm(post_form);

        if (result.success) {
            toast.success(result.message);
        } else {
            toast.error(result.error);
        }
    }

    const handleSave = async (e) => {
        e.preventDefault();

        if (formData.dementia_disease === "" || formData.block_call_phone_call === "" || formData.video_phone_bedroom === "" || formData.auto_answer === "" ||
            formData.address1 === "" || formData.suburb === "" || formData.state === "" || formData.postcode === "" || formData.delivery_check === false ||
            formData.contact_name === "" || formData.contact_phone === "" || formData.internet === '' || formData.eme_contact_name === "" || formData.eme_contact_phone === "") {
            setopenErrorModal(true);
            return;
        }
        if (formData.internet === "wifi" && formData.wifi_type === "") {
            setopenErrorModal(true);
            return;
        }

        if (formData.internet === "wifi" && formData.wifi_type === "home" && formData.wifi_home_pre_configure === "") {
            setopenErrorModal(true);
            return;
        }

        if (formData.internet === "wifi" && formData.wifi_type === "home" && formData.wifi_home_pre_configure === "yes" && (formData.wifi_ssid === "" || formData.wifi_password === "")) {
            setopenErrorModal(true);
            return;
        }

        if (formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "") {
            setopenErrorModal(true);
            return;
        }

        if (formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "no" && formData.wifi_home_pre_configure === "") {
            setopenErrorModal(true);
            return;
        }

        if (formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "no" && formData.wifi_home_pre_configure === "yes" && (formData.wifi_ssid === "" || formData.wifi_password === "")) {
            setopenErrorModal(true);
            return;
        }

        if (formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "yes" && formData.wifi_aged_care_special_req === "") {
            setopenErrorModal(true);
            return;
        }

        if (formData.video_phone_bedroom === "yes" && (formData.turn_off_at === "" || formData.turn_off_again_at === "")) {
            setopenErrorModal(true);
            return;
        }

        if (formData.auto_answer === "yes" && formData.auto_answer_delay === "") {
            setopenErrorModal(true);
            return;
        }

        if (formData.delivery_address_check === false && (formData.installation_address1 === "" || formData.installation_suburb === "" || formData.installation_state === "" || formData.installation_postcode === "")) {
            setopenErrorModal(true);
            return;
        }

        var post_form = { form_type: "telstra", device_id: user.id, form_status: "complete", form_data: JSON.stringify(formData) }
        const result = await PostKonnektForm(post_form);

        if (result.success) {
            toast.success(result.message);
            await GetData();
            setformSubmitted(true)
        } else {
            toast.error(result.error);
        }
    }

    useEffect(() => {
        GetData();
    }, []);

    return (
        <>
            <style>{`
                    .border-primary{border:3px solid #007bff!important}
                    #scrollablediv{max-height: 100vh; overflow: auto;}
                    #loginForm .form-label { font-weight:bold; color:black; }
                    #contactus{background-color: #F7F7F7}
                    #contactus_mobile{display:none;}

                @media (max-width: 767px) {
                      .col-6 { max-width: 100%; flex: 0 0 100%; }
                      .col-3 { max-width: 50%; flex: 0 0 50%;}
                      #loginForm .form-label, .form-check-label { font-size:13px; }
                      h2{ font-size: 19px }
                      
                      #contactus{display:none}
                      #scrollablediv{width: 100%; flex: 0 0 100%; max-width: 100%;}
                      #contactus_mobile{display:inline; background-color:#F8F8F8;}
                      #contactus_mobile .btn {font-size:10px; margin-top:5px}

                      .box-container{width:50%; padding-right:10px;padding-left:5px; padding-bottom:10px;}
                      .box-container img {max-width:100%;}
                      .box-container small{font-size: 70%; min-height:33px;}
                }`}</style>

            {isLoading ? (
                <div
                    style={{
                        background: "#fff",
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Loader />
                </div>
            ) : (
                <div style={{ backgroundColor: "#E6E6E6" }}>
                    <div id="contactus_mobile">
                        <div class="row" style={{ padding: "0.5rem 1.5rem 0.5rem 1.5rem" }}>
                            <div style={{ width: "2%" }}>
                                &nbsp;
                            </div>
                            <div style={{ width: "25%" }}>
                                <img src={`/images/konnekt_form_images/konnekt_logo.png`} alt="" style={{ maxWidth: "100%" }} />
                            </div>
                            <div style={{ width: "2%" }}>
                                &nbsp;
                            </div>
                            <div style={{ width: "44%" }}>
                                <small className="text-muted d-block mt-2">
                                    If you need help filling out this form, our friendly staff are happy to assist.
                                </small>
                            </div>
                            <div style={{ width: "2%" }}>
                                &nbsp;
                            </div>
                            <div style={{ width: "22%" }}>
                                <Button onClick={() => { setopenContactUs(true) }} class="btn cur-p btn-outline-dark">
                                    Contact Us
                                </Button>
                            </div>
                            <div style={{ width: "2%" }}>
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <div class="container" style={{ backgroundColor: "#fff" }}>

                        {user != null &&
                            <>
                                <Toaster />

                                {formSubmitted === false ?
                                    <form id="loginForm" onSubmit={handleSubmit}>
                                        <div class={"row"}>
                                            <div class="col-3" id="contactus">
                                                <div class="row">
                                                    <div class="col">
                                                        <img class="p-4" src={`/images/konnekt_form_images/konnekt_logo.png`} alt="" />
                                                    </div>
                                                </div>
                                                <div class="row mb-4">
                                                    <div class="col">
                                                        If you need help filling out this form, our friendly staff are happy to assist.
                                                    </div>
                                                </div>
                                                <div class="row mb-4">
                                                    <div class="col">
                                                        Email: <a href="mailto:support@konnekt.com.au">support@konnekt.com.au</a>
                                                    </div>
                                                </div>
                                                <div class="row mb-4">
                                                    <div class="col">
                                                        Phone: <u>1300 851 823</u> or <u>+61 3 8637 1188</u> (International)
                                                        <br />
                                                        Text (Support): <u>0412 917 467</u> or <u>+61 412 917 467</u>
                                                    </div>
                                                </div>
                                                <div class="row mb-4">
                                                    <div class="col">
                                                        Hours: 9:30am – 5:30pm Mon-Fri AEST or by arrangement
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-9" id="scrollablediv">
                                                <fieldset title={isReadOnly ? readOnlyTip : ""}>
                                                    <div class="py-5 text-center">
                                                        <h2>Konnekt Build Options for {user.name}</h2>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">Would you like a free accessory to boost the volume level for {user.name}?</label>
                                                            <div className="row mb-4">
                                                                {["none", "handset", "speakers"].map((option) => (
                                                                    <div className="box-container col-md-4" key={option}>
                                                                        <div className={`option-card p-3 border rounded ${formData.accessory === option ? "border-primary" : ""}`}
                                                                            onClick={() => { if (isReadOnly) return; setFormData((prev) => ({ ...prev, ["accessory"]: option })); }}>
                                                                            <img src={`/images/konnekt_form_images/${option === "none" ? "" : ""}${option === "handset" ? "accessory_handset.png" : ""}${option === "speakers" ? "accessory_speakers.png" : ""}`}
                                                                                alt="" style={{ marginBottom: '15px', minHeight: "100px" }} />
                                                                            <div style={{ clear: "both" }}></div>
                                                                            <label className="form-check-label fw-bold">
                                                                                {option === "none" && "No accessory"}
                                                                                {option === "handset" && "Handset"}
                                                                                {option === "speakers" && "External speakers"}
                                                                            </label>
                                                                            <small className="text-muted d-block mt-2">
                                                                                {option === "none" && "Use Konnekt’s built-in speakers."}
                                                                                {option === "handset" && "Provides a familiar phone experience."}
                                                                                {option === "speakers" && "Boosts volume level."}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">Where are you planning to put the videophone?</label>
                                                            <div className="row mb-4">
                                                                {["existing_table", "ikea_white", "wall_mount", "desk_mount"].map((option) => (
                                                                    <div className="box-container col-md-4 mb-3" key={option}>
                                                                        <div className={`option-card p-3 border rounded ${formData.placement === option ? "border-primary" : ""}`}
                                                                            onClick={() => { if (isReadOnly) return; setFormData((prev) => ({ ...prev, ["placement"]: option })); }}>
                                                                            <img src={`/images/konnekt_form_images/${option === "none" ? "" : ""}${option === "ikea_white" ? "ikea_table.png" : ""}${option === "ikea_wood" ? "ikea_table_1.png" : ""}${option === "wall_mount" ? "wall_mount_table.png" : ""}${option === "desk_mount" ? "desk_mount_table.png" : ""}`}
                                                                                alt="" style={{ marginBottom: '15px', minHeight: "100px" }} />
                                                                            <div style={{ clear: "both" }}></div>

                                                                            <label className="form-check-label fw-bold">
                                                                                {option === "existing_table" && "Existing table"}
                                                                                {option === "ikea_white" && "IKEA table - White"}
                                                                                {option === "ikea_wood" && "IKEA table - Wood finish"}
                                                                                {option === "wall_mount" && "Wall mounted (free)"}
                                                                                {option === "desk_mount" && "Desk mounted (+$85)"}
                                                                            </label>
                                                                            <small className="text-muted d-block mt-2" style={{ minHeight: "33px" }}>
                                                                                {option === "existing_table" && "I have enough space for the videophone on my existing table."}
                                                                                {option === "ikea_white" && "A free IKEA table will be shipped to the delivery address."}
                                                                                {option === "ikea_wood" && "A free IKEA table will be shipped to the delivery address."}
                                                                                {option === "wall_mount" && "The videophone will be mounted flat against the wall."}
                                                                                {option === "desk_mount" && "The videophone will be mounted on a desk using a monitor stand."}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">How will you connect the videophone to the internet?</label>
                                                            <div class="form-check">
                                                                <input name="internet" type="radio" class="form-check-input" value="wifi" onChange={handleChange} checked={formData.internet === "wifi"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Wi-Fi</label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input name="internet" type="radio" class="form-check-input" value="ethernet_cable" onChange={handleChange} checked={formData.internet === "ethernet_cable"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Ethernet cable</label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input name="internet" type="radio" class="form-check-input" value="4g_sim" onChange={handleChange} checked={formData.internet === "4g_sim"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Please provide a 4G modem and SIM at an additional cost of $5/month</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {formData.internet === "wifi" &&
                                                        <>
                                                            <div class="row mb-4">
                                                                <div class="col">
                                                                    <label class="form-label">What kind of Wi-Fi network are you connecting to?</label>
                                                                    <div class="form-check">
                                                                        <input name="wifi_type" type="radio" class="form-check-input" value="home" onChange={handleChange} checked={formData.wifi_type === "home"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">Home Wi-Fi</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input name="wifi_type" type="radio" class="form-check-input" value="aged_care" onChange={handleChange} checked={formData.wifi_type === "aged_care"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">Aged care facility Wi-Fi</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {formData.wifi_type === "aged_care" &&
                                                                <>
                                                                    <div class="row mb-4">
                                                                        <div class="col">
                                                                            <label class="form-label">Does the aged care facility Wi-Fi have any special requirements, such as a captive portal?</label>
                                                                            <div class="form-check">
                                                                                <input name="wifi_aged_care_configure" type="radio" class="form-check-input" value="no" onChange={handleChange} checked={formData.wifi_aged_care_configure === "no"} disabled={isReadOnly} />
                                                                                <label class="form-check-label">No special requirements (standard password)</label>
                                                                            </div>
                                                                            <div class="form-check">
                                                                                <input name="wifi_aged_care_configure" type="radio" class="form-check-input" value="yes" onChange={handleChange} checked={formData.wifi_aged_care_configure === "yes"} disabled={isReadOnly} />
                                                                                <label class="form-check-label">Special requirements/not sure</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {formData.wifi_aged_care_configure === "yes" &&
                                                                        <div class="row mb-4">
                                                                            <div class="col-9">
                                                                                <label class="form-label">Please describe the special requirements below. If you’re not sure, leave this section blank and we’ll call you to assist.</label>
                                                                                <textarea name="wifi_aged_care_special_req" class="form-control" value={formData.wifi_aged_care_special_req} rows="7"
                                                                                    placeholder="E.g. captive portal" onChange={handleChange} readOnly={isReadOnly} />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </>
                                                            }

                                                            {(formData.wifi_type === "home" || formData.wifi_aged_care_configure === "no") &&
                                                                <>
                                                                    <div class="row mb-4">
                                                                        <div class="col">
                                                                            <label class="form-label">Would you like us to pre-configure the Wi-Fi password for you?</label>
                                                                            <div class="form-check">
                                                                                <input name="wifi_home_pre_configure" type="radio" class="form-check-input" value="yes" onChange={handleChange} checked={formData.wifi_home_pre_configure === "yes"} disabled={isReadOnly} />
                                                                                <label class="form-check-label">Yes</label>
                                                                            </div>
                                                                            <div class="form-check">
                                                                                <input name="wifi_home_pre_configure" type="radio" class="form-check-input" value="no" onChange={handleChange} checked={formData.wifi_home_pre_configure === "no"} disabled={isReadOnly} />
                                                                                <label class="form-check-label">No, I’ll configure it myself when I receive the videophone</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {formData.wifi_home_pre_configure === "yes" &&
                                                                        <div class="row mb-4">
                                                                            <div class="col-3">
                                                                                <label class="form-label">Network name (SSID)</label>
                                                                                <input name="wifi_ssid" type="text" class="form-control" placeholder="" value={formData.wifi_ssid} onChange={handleChange} readOnly={isReadOnly} />
                                                                            </div>
                                                                            <div class="col-3">
                                                                                <label class="form-label">WPA2 Password</label>
                                                                                <input name="wifi_password" type={isPasswordVisible ? 'text' : 'password'} class="form-control" placeholder="" value={formData.wifi_password} onChange={handleChange} readOnly={isReadOnly} />
                                                                                <button type="button" onClick={togglePasswordVisibility} aria-label={isPasswordVisible ? "Hide password" : "Show password"} style={{ position: 'absolute', right: '10%', top: '70%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', }} >
                                                                                    {isPasswordVisible ? <i style={{ color: "black" }} className="fa fa-eye"> </i> : <i style={{ color: "black" }} className="fa fa-eye-slash"> </i>}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">Does {user.name} suffer from dementia, Alzheimer’s disease or other cognitive impairment?</label>
                                                            <div class="form-check">
                                                                <input name="dementia_disease" type="radio" class="form-check-input" value="no" onChange={handleChange} checked={formData.dementia_disease === "no"} disabled={isReadOnly} />
                                                                <label class="form-check-label">No</label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input name="dementia_disease" type="radio" class="form-check-input" value="yes" onChange={handleChange} checked={formData.dementia_disease === "yes"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Yes</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">Should the videophone block calls from unknown phone numbers?</label>
                                                            <div class="form-check">
                                                                <input name="block_call_phone_call" type="radio" class="form-check-input" value="no" onChange={handleChange} checked={formData.block_call_phone_call === "no"} disabled={isReadOnly} />
                                                                <label class="form-check-label">No</label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input name="block_call_phone_call" type="radio" class="form-check-input" value="yes" onChange={handleChange} checked={formData.block_call_phone_call === "yes"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Yes</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">If the videophone is placed in a bedroom, would you like the screen to turn off overnight?</label>
                                                            <div class="form-check">
                                                                <input name="video_phone_bedroom" type="radio" class="form-check-input" value="no" onChange={handleChange} checked={formData.video_phone_bedroom === "no"} disabled={isReadOnly} />
                                                                <label class="form-check-label">No</label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input name="video_phone_bedroom" type="radio" class="form-check-input" value="yes" onChange={handleChange} checked={formData.video_phone_bedroom === "yes"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Yes</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {formData.video_phone_bedroom === "yes" &&
                                                        <div class="row mb-4">
                                                            <div class="col-3">
                                                                <label class="form-label">Turn off at</label>
                                                                <input name="turn_off_at" type={isReadOnly ? "text" : "time"} class="form-control" placeholder="" value={isReadOnly ? formatTimeAmPm(formData.turn_off_at) : (formData.turn_off_at || "")} onChange={handleChange} readOnly={isReadOnly} />
                                                            </div>
                                                            <div class="col-3">
                                                                <label class="form-label">Turn on again at</label>
                                                                <input name="turn_off_again_at" type={isReadOnly ? "text" : "time"} class="form-control" placeholder="" value={isReadOnly ? formatTimeAmPm(formData.turn_off_again_at) : (formData.turn_off_again_at || "")} onChange={handleChange} readOnly={isReadOnly} />
                                                            </div>
                                                        </div>
                                                    }
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">Should the videophone automatically answer calls from certain contacts?</label>
                                                            <div class="form-check">
                                                                <input name="auto_answer" type="radio" class="form-check-input" value="no" onChange={handleChange} checked={formData.auto_answer === "no"} disabled={isReadOnly} />
                                                                <label class="form-check-label">No</label>
                                                            </div>
                                                            <div class="form-check">
                                                                <input name="auto_answer" type="radio" class="form-check-input" value="yes" onChange={handleChange} checked={formData.auto_answer === "yes"} disabled={isReadOnly} />
                                                                <label class="form-check-label">Yes</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {formData.auto_answer === "yes" &&
                                                        <>
                                                            <div class="row mb-4">
                                                                <div class="col-9">
                                                                    <label class="form-label">Please list the contacts who the videophone should auto-answer calls for.</label>
                                                                    <textarea name="auto_answer_yes_users" class="form-control" value={formData.auto_answer_yes_users} rows="7"
                                                                        placeholder="E.g. John Smith, Mary Smith, Frank Smith" onChange={handleChange} readOnly={isReadOnly} />
                                                                </div >
                                                            </div >
                                                            <div class="row mb-4">
                                                                <div class="col">
                                                                    <label class="form-label">How long should the videophone ring before auto-answering?</label>
                                                                    <div class="form-check">
                                                                        <input name="auto_answer_delay" type="radio" class="form-check-input" value="5sec" onChange={handleChange} checked={formData.auto_answer_delay === "5sec"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">5 seconds</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input name="auto_answer_delay" type="radio" class="form-check-input" value="10sec" onChange={handleChange} checked={formData.auto_answer_delay === "10sec"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">10 seconds</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input name="auto_answer_delay" type="radio" class="form-check-input" value="20sec" onChange={handleChange} checked={formData.auto_answer_delay === "20sec"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">20 seconds</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input name="auto_answer_delay" type="radio" class="form-check-input" value="30sec" onChange={handleChange} checked={formData.auto_answer_delay === "30sec"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">30 seconds (Recommend)</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input name="auto_answer_delay" type="radio" class="form-check-input" value="45sec" onChange={handleChange} checked={formData.auto_answer_delay === "45sec"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">45 seconds</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input name="auto_answer_delay" type="radio" class="form-check-input" value="60sec" onChange={handleChange} checked={formData.auto_answer_delay === "60sec"} disabled={isReadOnly} />
                                                                        <label class="form-check-label">60 seconds</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <label class="form-label">Please confirm the delivery address of the Konnekt videophone.</label>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">Delivery address (line 1)</label>
                                                            <input name="address1" type="text" class="form-control" placeholder="" value={formData.address1} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">Delivery address (line 2, optional)</label>
                                                            <input name="address2" type="text" class="form-control" placeholder="" value={formData.address2} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">City/Suburb</label>
                                                            <input name="suburb" type="text" class="form-control" placeholder="" value={formData.suburb} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-3">
                                                            <label class="form-label">State</label>
                                                            <input name="state" type="text" class="form-control" placeholder="" value={formData.state} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                        <div class="col-3">
                                                            <label class="form-label">Postcode</label>
                                                            <input name="postcode" type="text" class="form-control" placeholder="" value={formData.postcode} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">The videophone box is heavy (5kg). Please check the box below to confirm that an able-bodied person will be present to take delivery.</label>
                                                            <div class="form-check">
                                                                <input type="checkbox" class="form-check-input" disabled={isReadOnly} onChange={(e) => {
                                                                    if (isReadOnly) return;
                                                                    setFormData((prev) => ({ ...prev, ["delivery_check"]: e.target.checked }));
                                                                }} checked={formData.delivery_check} />
                                                                <label class="form-check-label">Yes, someone who can lift 5kg will be present to take delivery</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <label class="form-label">After delivery, who will call us to complete videophone setup?</label>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">Name</label>
                                                            <input name="contact_name" type="text" class="form-control" placeholder="e.g. Mary Jane" value={formData.contact_name} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">Contact phone number</label>
                                                            <input name="contact_phone" type="text" class="form-control" placeholder="e.g. 03 1234 5678" value={formData.contact_phone} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col">
                                                            <label class="form-label">Please confirm the address where the device will be installed/used. (This is required for 000 calls).</label>
                                                            <div class="form-check">
                                                                <input type="checkbox" class="form-check-input" disabled={isReadOnly} onChange={(e) => { if (isReadOnly) return; DeliveryAddressChange(e.target.checked); }} checked={formData.delivery_address_check} />
                                                                <label class="form-check-label">Same as delivery address</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        formData.delivery_address_check === false &&
                                                        <>
                                                            <div class="row mb-4">
                                                                <div class="col-6">
                                                                    <label class="form-label">Installation address (line 1)</label>
                                                                    <input name="installation_address1" type="text" class="form-control" placeholder="" value={formData.installation_address1} onChange={handleChange} readOnly={isReadOnly} />
                                                                </div>
                                                            </div>
                                                            <div class="row mb-4">
                                                                <div class="col-6">
                                                                    <label class="form-label">Installation address (line 2, optional)</label>
                                                                    <input name="installation_address2" type="text" class="form-control" placeholder="" value={formData.installation_address2} onChange={handleChange} readOnly={isReadOnly} />
                                                                </div>
                                                            </div>
                                                            <div class="row mb-4">
                                                                <div class="col-6">
                                                                    <label class="form-label">City/Suburb</label>
                                                                    <input name="installation_suburb" type="text" class="form-control" placeholder="" value={formData.installation_suburb} onChange={handleChange} readOnly={isReadOnly} />
                                                                </div>
                                                            </div>
                                                            <div class="row mb-4">
                                                                <div class="col-3">
                                                                    <label class="form-label">State</label>
                                                                    <input name="installation_state" type="text" class="form-control" placeholder="" value={formData.installation_state} onChange={handleChange} readOnly={isReadOnly} />
                                                                </div>
                                                                <div class="col-3">
                                                                    <label class="form-label">Postcode</label>
                                                                    <input name="installation_postcode" type="text" class="form-control" placeholder="" value={formData.installation_postcode} onChange={handleChange} readOnly={isReadOnly} />
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <label class="form-label">Please enter an emergency contact for {user.name} (This is required for 000 calls).</label>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">Emergency contact name</label>
                                                            <input name="eme_contact_name" type="text" class="form-control" placeholder="e.g. Mary Jane" value={formData.eme_contact_name} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-4">
                                                        <div class="col-6">
                                                            <label class="form-label">Emergency contact phone number</label>
                                                            <input name="eme_contact_phone" type="text" class="form-control" placeholder="e.g. 03 1234 5678" value={formData.eme_contact_phone} onChange={handleChange} readOnly={isReadOnly} />
                                                        </div>
                                                    </div>
                                                    {
                                                        !isReadOnly && (
                                                            <div class="row mb-4">
                                                                <div class="col-6">
                                                                    <div class="form-check-inline">

                                                                        <Button onClick={handleSaveDraft} class="btn cur-p btn-outline-dark" disabled={isReadOnly}>
                                                                            Save Draft
                                                                        </Button>
                                                                    </div>
                                                                    <div class="form-check-inline">

                                                                        <Button onClick={handleSave} variant="black" >
                                                                            Submit
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </fieldset >
                                            </div >

                                        </div >
                                    </form >
                                    :
                                    <div class={"row p-4"}>
                                        <div class="col">
                                            <div class="row mb-4">
                                                <div class="col-3">
                                                    <img src={`/images/konnekt_form_images/konnekt_logo.png`} alt="" />
                                                </div>
                                            </div>
                                            <div class="row mb-4">
                                                <div class="col-3">
                                                </div>
                                                <div class="col" style={{ textAlign: "center" }}>
                                                    <i style={{ color: "green", fontSize: "14rem" }} className="fa fa-check-circle"></i>
                                                </div>
                                                <div class="col-3">
                                                </div>
                                            </div>
                                            <div class="row mb-4">
                                                <div class="col-3">
                                                </div>
                                                <div class="col" style={{ textAlign: "center" }}>
                                                    <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                                                        Your build options have been successfully submitted.
                                                    </span>
                                                </div>
                                                <div class="col-3">
                                                </div>
                                            </div>
                                            <div class="row mb-5">
                                                <div class="col-3">
                                                </div>
                                                <div class="col" style={{ textAlign: "center" }}>
                                                    <br /> <br /> <br /> <br /> <br /> <br /><br /> <br /> <br /> <br /> <br /> <br /> </div>
                                                <div class="col-3">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    openErrorModal && (
                                        <div className="modal" tabIndex={"-1"} role="dialog">
                                            <div className="modal-dialog-scrollable" role="document">
                                                <div className="modal-content" style={{ maxWidth: "100%" }}>
                                                    <div className="modal-header" style={{ padding: "0" }}>
                                                        <h1 className="modal-title">Please complete these required fields</h1>
                                                        <button className="close-button" onClick={() => setopenErrorModal(false)} >
                                                            &times;
                                                        </button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div class="row">
                                                            <div class="col" style={{ height: "50vh", overflow: "auto" }}>
                                                                <ul style={{ listStyleType: "disc" }}>
                                                                    {formData.internet === "" && <li>How will you connect the videophone to the internet?</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "" && <li>What kind of Wi-Fi network are you connecting to?</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "home" && formData.wifi_home_pre_configure === "" && <li>Would you like us to pre-configure the Wi-Fi password for you?</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "home" && formData.wifi_home_pre_configure === "yes" && (formData.wifi_ssid === "" || formData.wifi_password === "") && <li>Network name (SSID) & WPA2 Password</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "" && <li>Does the aged care facility Wi-Fi have any special requirements, such as a captive portal?</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "no" && formData.wifi_home_pre_configure === "" && <li>Would you like us to pre-configure the Wi-Fi password for you?</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "no" && formData.wifi_home_pre_configure === "yes" && (formData.wifi_ssid === "" || formData.wifi_password === "") && <li>Network name (SSID) & WPA2 Password</li>}
                                                                    {formData.internet === "wifi" && formData.wifi_type === "aged_care" && formData.wifi_aged_care_configure === "yes" && formData.wifi_aged_care_special_req === "" && <li> Please describe the special requirements below.If you’re not sure, leave this section blank and we’ll call you to assist.</li>}

                                                                    {formData.dementia_disease === "" && <li>Does {user.name} suffer from dementia, Alzheimer’s disease or other cognitive impairment?</li>}
                                                                    {formData.block_call_phone_call === "" && <li>Should the videophone block calls from unknown phone numbers?</li>}
                                                                    {formData.video_phone_bedroom === "" && <li> If the videophone is placed in a bedroom, would you like the screen to turn off overnight?</li>}
                                                                    {formData.video_phone_bedroom === "yes" && formData.turn_off_at === "" && <li>Turn off at</li>}
                                                                    {formData.video_phone_bedroom === "yes" && formData.turn_off_again_at === "" && <li>Turn on again at</li>}
                                                                    {formData.auto_answer === "" && <li>Should the videophone automatically answer calls from certain contacts?</li>}
                                                                    {formData.auto_answer === "yes" && formData.auto_answer_delay === "" && <li>How long should the videophone ring before auto-answering?</li>}

                                                                    {formData.address1 === "" && <li>Delivery address (line 1)</li>}
                                                                    {formData.suburb === "" && <li>City/Suburb</li>}
                                                                    {formData.state === "" && <li>State</li>}
                                                                    {formData.postcode === "" && <li>Postcode</li>}
                                                                    {formData.delivery_check === false && <li>The videophone box is heavy (5kg). Please check the box below to confirm that an able-bodied person will be present to take delivery.</li>}
                                                                    {formData.contact_name === "" && <li>Contact Name</li>}
                                                                    {formData.contact_phone === "" && <li>Contact phone number</li>}

                                                                    {formData.eme_contact_name === "" && <li>Emergency contact name</li>}
                                                                    {formData.eme_contact_phone === "" && <li>Emergency contact phone number</li>}

                                                                    {formData.delivery_address_check === false && formData.installation_address1 === "" && <li>Delivery address (line 1)</li>}
                                                                    {formData.delivery_address_check === false && formData.installation_suburb === "" && <li>City/Suburb</li>}
                                                                    {formData.delivery_address_check === false && formData.installation_state === "" && <li>State</li>}
                                                                    {formData.delivery_address_check === false && formData.installation_postcode === "" && <li>Postcode</li>}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer" style={{ display: "inline" }}>
                                                        <Button onClick={() => setopenErrorModal(false)} class="btn cur-p btn-outline-dark">
                                                            OK
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    openContactUs && (
                                        <div className="modal" tabIndex={"-1"} role="dialog">
                                            <div className="modal-dialog-scrollable" role="document">
                                                <div className="modal-content" style={{ width: "100%" }}>
                                                    <div className="modal-header" style={{ padding: "0" }}>
                                                        <span className="modal-title">Contact Us</span>
                                                        <button className="close-button" onClick={() => setopenContactUs(false)} >
                                                            &times;
                                                        </button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div class="row mb-4">
                                                            <div class="col">
                                                                Email: <a href="mailto:support@konnekt.com.au">support@konnekt.com.au</a>
                                                            </div>
                                                        </div>
                                                        <div class="row mb-4">
                                                            <div class="col">
                                                                Phone: <u>1300 851 823</u> or <u>+61 3 8637 1188</u> (International)
                                                                <br />
                                                                Text (Support): <u>0412 917 467</u> or <u>+61 412 917 467</u>
                                                            </div>
                                                        </div>
                                                        <div class="row mb-4">
                                                            <div class="col">
                                                                Hours: 9:30am – 5:30pm Mon-Fri AEST or by arrangement
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    </div >
                </div >
            )}
        </>
    )
}

export default KonnektFormDisplay;